import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { VariantProps } from "~/components/section/section-top/variant/types";
import type { twoSectionTopWidgetQueue$key } from "~/queries/__generated__/twoSectionTopWidgetQueue.graphql";

import {
  Container,
  Primary,
  Secondary,
  StyledContentItemHomeSecondary,
  StyledContentItemSectionTopLeadSecondary,
} from "./styles";

type Props = {
  className?: string;
  reference: twoSectionTopWidgetQueue$key;
} & VariantProps;

export const SectionTopWidgetTwo: FunctionComponent<Props> = ({
  className,
  onClick,
  reference,
}) => {
  const data = useFragment(
    graphql`
      fragment twoSectionTopWidgetQueue on Queue
      @argumentDefinitions(
        excludeEntityIds: { type: "[String]" }
        first: { type: "Int", defaultValue: 5 }
      ) {
        variantTwoItems: items(first: $first, exclude: { entityIds: $excludeEntityIds }) {
          edges {
            node {
              ... on Content {
                ...entityLink
                ...homeSecondaryContentItemContent
                ...sectionTopLeadSecondaryContentItemContent
              }
            }
          }
        }
      }
    `,
    reference,
  );

  const items =
    data?.variantTwoItems?.edges?.map(({ node }) => node).filter(node => notEmpty(node)) ?? [];

  if (items.length === 0) return null;

  const [leading, ...rest] = items;

  return (
    <Container className={className}>
      <Primary>
        <StyledContentItemSectionTopLeadSecondary
          reference={leading}
          withComment={true}
          onClick={entityId => onClick(entityId)}
        />
      </Primary>
      {rest?.length > 0 && (
        <Secondary>
          {rest?.slice(0, 4)?.map((item, index) => (
            <StyledContentItemHomeSecondary
              key={index}
              reference={item}
              withComment={true}
              onClick={entityId => onClick(entityId)}
            />
          ))}
        </Secondary>
      )}
    </Container>
  );
};

SectionTopWidgetTwo.displayName = "SectionTopWidgetTwo";
